import React, { Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import {
  ACTIVATE_ACCOUNT,
  ATP_LOGIN,
  ATP_REGISTER,
  BASE_URL,
  DEACTIVATE_FORGOT_PASSWORD,
  EMAIL_VERIFICATION,
  FORGOT_PASSWORD,
  REGISTER,
  RESET_PASSWORD,
  USER_CPD_ACTIVITIES,
  USER_CPD_MY_ACTIVITIES,
} from "../data/Constants";
import ErrorBoundary from "../pages/ErrorBoundary";
import Registration from "../pages/Auth/Registration";
import EmailVerification from "../pages/Auth/EmailVerification";
import ActivateAccount from "../pages/Auth/ActivateAccount";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import ResetPassword from "../pages/Auth/ResetPassword";
import DeactivateForgotPassword from "../pages/Auth/DeactivateForgotPassword";
import SignIn from "../pages/Auth/SignIn";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import MasterLayout from "../layouts/components/UserLayout/MasterLayout";
import AtpMasterLayout from "../layouts/components/AtpLayout/AtpMasterLayout";
import AtpSignIn from "../pages/Auth/AtpSignIn";
import AtpSignUp from "../pages/Auth/AtpSignUp";
import AtpProtectedRoute from "./AtpProtectedRoute";
import Approved from "../pages/CPDActivities/cpdActivitiesTab/Tabing/Approved";
import Pending from "../pages/CPDActivities/cpdActivitiesTab/Tabing/Pending";
import Rejected from "../pages/CPDActivities/cpdActivitiesTab/Tabing/Rejected";
import MobilePayment from "../pages/mobilePayment";

const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const Profile = React.lazy(() => import("../pages/Profile"));
const ProfileDetails = React.lazy(() => import("../pages/Profile/Profile"));
const ProfileSettings = React.lazy(() => import("../pages/Profile/Settings"));
const Certifications = React.lazy(() => import("../pages/certifications"));
const Layout = React.lazy(() =>
  import("../pages/CPDActivities/cpdActivitiesUser/components/Layout")
);
const MyCPDActivities = React.lazy(() =>
  import("../pages/CPDActivities/cpdActivitiesUser/components/MyCPDActivities")
);
const Billing = React.lazy(() => import("../pages/billing"));
const ATPBilling = React.lazy(() => import("../pages/atpBilling"));
const ATPBillingPaymentHistory = React.lazy(() =>
  import("../pages/atpBilling/components/PaymentHistory")
);
const ATPBillignSubscriptionStatus = React.lazy(() =>
  import("../pages/atpBilling/components/ATPBillingSubscriptionStatus")
);
const FirstCertificateGeneration = React.lazy(() =>
  import(
    "../pages/Dashboard/components/ApplicationStatus/FirstCertificateGeneration"
  )
);
const HomePage = React.lazy(() => import("../pages/Dashboard/HomePage"));
const CPDActivity = React.lazy(() =>
  import("../pages/CPDActivities/cpdActivitiesTab/CPDTabLayout")
);
const AtpProfile = React.lazy(() => import("../pages/AtpProfile"));
const AllActivites = React.lazy(() =>
  import("../pages/CPDActivities/cpdActivitiesUser/components/AllListings")
);
const AtpResources = React.lazy(() => import("../pages/AtpResources"));
const AtpDashboard = React.lazy(() => import("../pages/AtpDashboard"));
const Endorsement = React.lazy(() => import("../pages/Notifications/EndorsementProfileInfo"));
const NotificationCenter = React.lazy(() => import("../pages/Notifications/notificationCenter"));
const ProfileInformation = React.lazy(() => import("../pages/Notifications/EndorsementProfileInfo"));
export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={BASE_URL} errorElement={<ErrorBoundary />}>
      <Route
        index
        element={
          <PublicRoute>
            <SignIn />
          </PublicRoute>
        }
      />
      <Route
        path={REGISTER}
        element={
          <PublicRoute>
            <Registration />
          </PublicRoute>
        }
      />
      <Route
        path={ATP_REGISTER}
        element={
          <PublicRoute>
            <AtpSignUp />
          </PublicRoute>
        }
      />
      <Route
        path={ATP_LOGIN}
        element={
          <PublicRoute>
            <AtpSignIn />
          </PublicRoute>
        }
      />
      <Route
        path={EMAIL_VERIFICATION}
        element={
          <PublicRoute>
            <EmailVerification />
          </PublicRoute>
        }
      />
      <Route
        path={`${ACTIVATE_ACCOUNT}/:token`}
        element={
          <PublicRoute>
            <ActivateAccount />
          </PublicRoute>
        }
      />
      <Route
        path={FORGOT_PASSWORD}
        element={
          <PublicRoute>
            <ForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        path={`${RESET_PASSWORD}/:token`}
        element={
          <PublicRoute>
            <ResetPassword />
          </PublicRoute>
        }
      />
      <Route
        path={`${DEACTIVATE_FORGOT_PASSWORD}/:token`}
        element={
          <PublicRoute>
            <DeactivateForgotPassword />
          </PublicRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <MasterLayout />
          </ProtectedRoute>
        }
      >
        <Route
          path="dashboard"
          element={
            <Suspense>
              <Dashboard />
            </Suspense>
          }
        >
          <Route path="notifications" element={<NotificationCenter />} />
          <Route path="endorsement" element={<Endorsement />} >
            <Route path=":id" element={<ProfileInformation />} />
          </Route>
          <Route
            index
            element={
              <Suspense>
                <HomePage />
              </Suspense>
            }
          />
          {/* Learn More after completed status(In Dashboard) */}
          <Route
            path="certificate-information"
            element={
              <Suspense>
                <FirstCertificateGeneration />
              </Suspense>
            }
          />
        </Route>
        <Route
          path={USER_CPD_ACTIVITIES}
          element={
            <Suspense>
              <Layout />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense>
                <AllActivites />
              </Suspense>
            }
          />
          <Route
            path={USER_CPD_MY_ACTIVITIES}
            element={
              <Suspense>
                <MyCPDActivities />
              </Suspense>
            }
          />
        </Route>

        <Route
          path="profile"
          element={
            <Suspense>
              <Profile />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense>
                <ProfileDetails />
              </Suspense>
            }
          />
          <Route
            path="settings"
            element={
              <Suspense>
                <ProfileSettings />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="billing"
          element={
            <Suspense>
              <Billing />
            </Suspense>
          }
        />
        <Route
          path="certifications"
          element={
            <Suspense>
              <Certifications />
            </Suspense>
          }
        />
      </Route>
      <Route
        path="atp"
        element={
          <AtpProtectedRoute>
            <AtpMasterLayout />
          </AtpProtectedRoute>
        }
      >
        <Route
          path="dashboard"
          element={
            <Suspense>
              <Dashboard />
            </Suspense>
          }
        >
          <Route
            index
            element={
              <Suspense>
                <AtpDashboard />
              </Suspense>
            }
          />
          <Route path="notifications" element={<NotificationCenter />} />
        </Route>
        <Route
          path="cpdactivities"
          element={
            <Suspense>
              <CPDActivity />
            </Suspense>
          }
        >
          <Route path="approved" element={<Approved />} />
          <Route path="pending" element={<Pending />} />
          <Route path="rejected" element={<Rejected />} />
        </Route>
        <Route
          path="profile"
          element={
            <Suspense>
              <AtpProfile />
            </Suspense>
          }
        />
        <Route
          path="billing"
          element={
            <Suspense>
              <ATPBilling />
            </Suspense>
          }
        >
          <Route index element={<ATPBillingPaymentHistory />} />
          <Route
            path="subscription-status"
            element={<ATPBillignSubscriptionStatus />}
          />
        </Route>
        <Route
          path="resources"
          element={
            <Suspense>
              <AtpResources />
            </Suspense>
          }
        />
      </Route>
      <Route path="mobile_payment" element={<MobilePayment />} />
    </Route>
  )
);
